// Tech Debt: Would be nicer to get these from the back-end
export const AP_PROFESSIONAL_IDS = [
    /* archipro-au */ 113232, /* archipro */ 26182, /* archipro-ca */ 210078,
];

const isApProfessional = (professionalId: number): boolean => {
    return AP_PROFESSIONAL_IDS.includes(professionalId);
};

export default isApProfessional;
